// extracted by mini-css-extract-plugin
module.exports = {"container":"Status_container__2erG5","checkmark":"Status_checkmark__2DvQ5"};